import RouterComponent from "./views/routes";

function App() {
  return (
    <RouterComponent />

  );
}

export default App;
